import React, { useState, useRef, useEffect, FC } from 'react';
import { removeTrailingSlashFromPath } from '../../../utils';
import { googleClickDropdownEvent } from '../../../utils/analytics';
import { documentService, windowService } from '../../../utils/window.utils';
import Icon from '../../@shared/icon';
import RoutableNotEditableLink from '../../@shared/routableNotEditableLink';
import { TFirstFilterProps } from '../types/seriesListing.types';

const FirstFilter: FC<TFirstFilterProps> = (props) => {
  const dropdownLineRef = useRef(null);
  const dropdownLineInputRef = useRef(null);
  const {
  showDropdown,
  setShowDropdown,
  showPopup,
  setShowPopup,
  setDropdownTypeText,
  applyFilter,
  handleClickOutside,
  isMobile,
  currentLineTitle,
  isSuperSerie,
  lines,
  linesSeries,
  ALLTYPES,
  iconType,
  } = props;

  const [dropdownLineText, setDropdownLineText] = useState(currentLineTitle);

  useEffect(() => {
    const mouseDownHandler = (event) => {
      handleClickOutside(event, dropdownLineRef, dropdownLineInputRef, setShowDropdown);
    };
    if (documentService()) {
      documentService().addEventListener?.('mousedown', mouseDownHandler);
    }
    return () => {
      documentService()?.removeEventListener?.('mousedown', mouseDownHandler);
      };
  }, [dropdownLineRef]);

  const getLinkLine = (line: string) => {
    const paths = removeTrailingSlashFromPath(windowService().location.pathname).split('/');

    if (isSuperSerie) {
      paths.splice(-1);
    } else {
      paths.pop();
    }

    paths.push(line);
    return paths.join('/');
  };

  const data = isSuperSerie && linesSeries.length > 0 ? linesSeries : lines;
  
  return (
    <li key={dropdownLineText} className={`product-card-filters__block ${showDropdown ? 'product-card-filters__block--mobile' : null}`}>
      <div
        className="product-card-filters__block-item product-card-filters__block--selected"
        onClick={() => {
          setShowDropdown(!showDropdown);
          isMobile && setShowPopup(!showPopup);
        }}
        ref={dropdownLineInputRef}
      >
        {showDropdown && <span></span>}
        <span className={'product-card-filters__block-item-text product-card-filters__block-item-text--selected'}>{dropdownLineText}</span>
        <Icon iconName={showDropdown ? iconType : 'arrow-chevron-down'} size={24} />
      </div>
      {showDropdown && (
        <ul
          className={`product-card-filters__dropdown-wrapper ${showDropdown ? 'product-card-filters__dropdown-wrapper--mobile' : null}`}
          ref={dropdownLineRef}
        >
          {data.map((line, filterIndex) => (
            <li key={line.title} className="product-card-filters__dropdown-element">
              <RoutableNotEditableLink
                className="product-card-filters__dropdown-element-link"
                href={getLinkLine(line.titleUrl)}
                onClick={() => {
                  setDropdownLineText(line.title);
                  setDropdownTypeText(ALLTYPES);
                  applyFilter(ALLTYPES);
                  setShowDropdown(false);
                  isMobile && setShowPopup(!showPopup);
                  googleClickDropdownEvent(dropdownLineText, line.title, filterIndex + 1);
                }}
              >
                {line.title}
              </RoutableNotEditableLink>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default FirstFilter;
